import { z } from 'zod';
import { INSTRUMENT_TYPE } from '@fortem-monorepo/constants';
import { baseStructuredSchema } from './shared/base-structured.schema';
import { contractTypeSchema } from './shared/contract-type.schema';
import { knockdownInputLevelSchema } from './shared/knockdown-input-level.schema';
import { sideSchema } from './shared/side.schema';
export const digitalSchema = baseStructuredSchema.extend({
    instrument_type: z.literal(INSTRUMENT_TYPE.Digital),
    contract_type: contractTypeSchema,
    side: sideSchema,
    coupon_rate_annual: z.number(),
    payoff_barrier_level: z.number(),
    knockdown_input_level: knockdownInputLevelSchema,
});
